<script>
import Layout from '@layouts/main.vue'
import {
  authComputed,
  cancelReasonComputed,
  cancelReasonMethods,
  cityComputed,
  cityMethods,
  contractComputed,
  contractMethods,
  dutyMethods,
  inviteMethods,
  registrationComputed,
  registrationMethods,
  userFileComputed,
  userFileMethods,
  userMethods,
} from '@state/helpers'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/lt'
import dayjs from 'dayjs'

export default {
  page() {
    return {
      title: this.isEdit ? this.name : 'Sukurti profilį',
    }
  },

  components: { Layout, DatePicker },

  data() {
    return {
      errorMessage: null,
      isLoading: false,
      failedField: null,
      name: '',
      form: {
        password: '',
        email: '',
        role: 'volunteer',
        phone: '',
        status: 1,
        notes: '',
        city: '',
        contract_no: '',
        contract_from: '',
        contract_to: '',
        contract_cancel_reason: '',
        outfit: false,
        photo_agreement: false,
        can_be_deleted: false,
        legal_certificate: false,
        health_certificate: false,
        certificate: false,
        group: '',
        edition: '',
        outfit_size: '',
        birth_date: null,
        started_at: null,
        health_certificate_to: '',
        nv_program: false,
        kc_program: false,
        drauge_program: false,
        grupese_program: false,
      },
      statuses: [
        {
          id: 1,
          label: 'Aktyvus',
        },
        {
          id: 2,
          label: 'Negalioja',
        },
        {
          id: 3,
          label: 'Sustabdyta',
        },
      ],
      dialogs: {
        files: {
          visible: false,
          uploadBtnText: 'Įkelti failą',
        },

        contracts: {
          visible: false,
        },

        studies: {
          visible: false,
        },
      },
    }
  },

  computed: {
    ...authComputed,

    ...userFileComputed,

    ...cityComputed,

    ...cancelReasonComputed,

    ...contractComputed,

    ...registrationComputed,

    userId() {
      return this.$route.params.id
    },

    isEdit() {
      return !!this.userId
    },

    roles() {
      const options = [
        {
          id: 'volunteer',
          label: 'Savanoris',
        },
        {
          id: 'coordinator',
          label: 'Koordinatorius',
        },
      ]
      if (this.currentUser.role === 'admin') {
        options.push({
          id: 'admin',
          label: 'Administratorius',
        })
      }
      return options
    },

    contractEnded() {
      if (!this.form.contract_to) {
        return false
      }

      return dayjs(this.form.contract_to) < dayjs()
    },

    studies() {
      if (!this.registrations || !this.registrations.length) {
        return []
      }

      return this.registrations.filter(
        (registration) =>
          dayjs(registration.event_date) < dayjs() &&
          registration.event_purpose === 'Tęstiniai mokymai',
      )
    },
  },

  created() {
    this.fetchAllCancelReasons()
    this.fetchAllCities()
    this.setFilterCity()
    this.fetchUser()
    this.fetchAllRegistrations({ start_date: '2020-06-01' })
  },

  methods: {
    ...userMethods,

    ...userFileMethods,

    ...inviteMethods,

    ...cityMethods,

    ...cancelReasonMethods,

    ...contractMethods,

    ...registrationMethods,

    ...dutyMethods,

    fetchUser() {
      if (this.isEdit) {
        this.viewUser(this.userId)
          .then(this.updateUserForm)
          .catch(() => this.$router.push({ name: 'users' }))
        this.fetchUserFiles()
        this.fetchAllContracts(this.userId)
      }
    },

    setFilterCity() {
      this.form.city = this.currentUser.city
    },

    fetchUserFiles() {
      this.fetchAllUserFiles(this.userId)
    },

    updateUserForm(user) {
      Object.keys(this.form).forEach((field) => {
        this.form[field] = user[field]
      })
      this.name = `${user.first_name} ${user.last_name}`
    },

    onSubmitForm() {
      this.resetFormState()

      this.form.first_name = this.name.split(' ')[0]
      this.form.last_name = this.name.replace(this.form.first_name + ' ', '')
      const action = this.isEdit ? this.updateUser : this.createUser

      return action({
        id: this.userId,
        ...this.form,
      })
        .then((token) => {
          this.resetFormState()
          this.$router.push({ name: 'users' })
        })
        .catch((error) => {
          this.isLoading = false
          this.errorMessage = 'Formoje yra klaidų.'
          this.failedField = error.response.data.error.replace(/.*: /, '')
        })
    },

    onClickUserDelete() {
      if (confirm('Ar tikrai norite ištrinti įrašą?')) {
        this.deleteUser(this.userId).then(this.$router.push({ name: 'users' }))
      }
    },

    resetFormState() {
      this.isLoading = true
      this.errorMessage = null
      this.failedField = null
    },

    onClickFiles() {
      this.dialogs.files.visible = true
    },

    onFileChange(file) {
      if (!file) {
        return
      }

      const { userId } = this
      this.createUserFile({ userId, file }).then(this.fetchUserFiles)
    },

    onClickFileDelete(id) {
      if (confirm('Ar tikrai norite pašalinti failą?')) {
        const { userId } = this
        this.deleteUserFile({ userId, id }).then(this.fetchUserFiles)
      }
    },

    onClickInvite(id) {
      if (confirm('Ar tikrai norite išsiųsti pakvietimą?')) {
        this.createInvite(this.userId)
      }
    },

    onClickContracts() {
      this.dialogs.contracts.visible = true
    },

    onClickStudies() {
      this.dialogs.studies.visible = true
    },

    async onClickDeleteContract(contract) {
      if (confirm('Ar tikrai norite ištrinti sutartį?')) {
        await this.deleteContract({ userId: this.userId, id: contract.id })
        this.fetchAllContracts(this.userId)
      }
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <h1 class="text-2xl font-bold">
          <template v-if="isEdit">{{ name }}</template>
          <template v-else> Sukurti profilį </template>
        </h1>
      </template>
      <template v-slot:actions>
        <div>
          <base-btn class="py-2 px-4" @click="$router.push({ name: 'users' })">
            <font-awesome-icon :icon="['fas', 'undo']" class="mr-1" />
            Grįžti atgal
          </base-btn>
        </div>
      </template>
    </base-page-title>

    <p v-if="errorMessage" class="text-error mb-4">
      {{ errorMessage }}
    </p>

    <form @submit.prevent="onSubmitForm">
      <div class="mb-4">
        <base-label-input
          v-model="name"
          type="text"
          required
          :error="failedField === 'first_name' || failedField === 'last_name'"
          label="Vardas, pavardė"
        />
      </div>

      <div class="flex flex-row">
        <div class="mb-4 flex-1 pr-4">
          <base-label-input
            v-model="form.email"
            type="text"
            required
            :error="failedField === 'email'"
            label="El. pašto adresas"
            autocomplete="off"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-input
            v-model="form.password"
            type="password"
            required
            :error="failedField === 'password'"
            label="Slaptažodis"
            autocomplete="off"
          />
        </div>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-select
            v-model="form.role"
            required
            :error="failedField === 'role'"
            label="Statusas"
            :options="roles"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-select
            v-model="form.status"
            required
            :error="failedField === 'status'"
            label="Būsena"
            :options="statuses"
          />
        </div>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-check
            v-model="form.nv_program"
            type="text"
            label="Niekieno vaikai programa"
          />
        </div>

        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-check
            v-model="form.kc_program"
            type="text"
            label="Krizių centro programa"
          />
        </div>

        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-check
            v-model="form.drauge_program"
            type="text"
            label="Drauge programa"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-check
            v-model="form.grupese_program"
            type="text"
            label="Grupių programa"
          />
        </div>
      </div>

      <div v-if="form.outfit" class="mb-4">
        <base-label-input
          v-model="form.outfit_size"
          type="text"
          :error="failedField === 'outfit_size'"
          label="Aprangos dydis"
        />
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-input
            v-model="form.group"
            :error="failedField === 'group'"
            label="Grupė"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-input
            v-model="form.edition"
            :error="failedField === 'edition'"
            label="Laida"
          />
        </div>
      </div>

      <div class="mb-4">
        <base-label-input
          v-model="form.phone"
          type="text"
          required
          :error="failedField === 'phone'"
          label="Telefono numeris"
        />
      </div>

      <div class="mb-4">
        <base-label-text label="Gimimo data" class="datepicker">
          <DatePicker
            v-model="form.birth_date"
            value-type="format"
            format="YYYY-MM-DD"
          />
        </base-label-text>
      </div>

      <div class="mb-4">
        <base-label-text label="Pradėjo savanoriauti" class="datepicker">
          <DatePicker
            v-model="form.started_at"
            value-type="format"
            format="YYYY-MM-DD"
          />
        </base-label-text>
      </div>

      <div class="mb-4">
        <base-label-text
          v-if="currentUser.role === 'admin'"
          label="Miestas"
          required
        >
          <base-select-input
            v-model="form.city"
            :blank-option="{ id: '', label: '' }"
            :options="cityOptions || []"
            required
            :error="failedField === 'city'"
          />
        </base-label-text>
        <base-label-text v-else label="Miestas" required>
          <base-input
            v-model="form.city"
            :blank-option="{ id: '', label: '' }"
            :options="cityOptions || []"
            class="w-full input rounded"
            required
            readonly
            :error="failedField === 'city'"
          />
        </base-label-text>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="mb-3 flex-1 lg:pr-4">
          <base-label-input
            v-model="form.contract_no"
            type="text"
            :error="failedField === 'contract_no'"
            label="Sutarties numeris"
          />
        </div>

        <div class="mb-3 flex-1 lg:pr-4">
          <base-label-text label="Sutartis nuo" class="datepicker">
            <DatePicker
              v-model="form.contract_from"
              value-type="format"
              format="YYYY-MM-DD"
            />
          </base-label-text>
        </div>

        <div class="mb-3 flex-1 lg:pr-4">
          <base-label-text label="Sutartis iki" class="datepicker">
            <DatePicker
              v-model="form.contract_to"
              value-type="format"
              format="YYYY-MM-DD"
            />
          </base-label-text>
        </div>

        <div class="mb-3 flex-1">
          <base-label-text label="Med. pažyma iki" class="datepicker">
            <DatePicker
              v-model="form.health_certificate_to"
              value-type="format"
              format="YYYY-MM-DD"
            />
          </base-label-text>
        </div>
      </div>

      <div v-if="contractEnded" class="mb-4">
        <base-label-text label="Sutarties nutraukimo priežastis">
          <base-select-input
            v-model="form.contract_cancel_reason"
            :blank-option="{ id: '', label: '' }"
            :options="cancelReasonOptions || []"
            :error="failedField === 'contract_cancel_reason'"
          />
        </base-label-text>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-check
            v-model="form.health_certificate"
            type="text"
            :error="failedField === 'health_certificate'"
            label="Med. pažyma"
          />
        </div>

        <div class="mb-4 flex-1 lg:pr-4">
          <base-label-check
            v-model="form.legal_certificate"
            type="text"
            :error="failedField === 'legal_certificate'"
            label="Teistumo pažyma"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-check
            v-model="form.outfit"
            type="text"
            :error="failedField === 'outfit'"
            label="Apranga"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-check
            v-model="form.certificate"
            type="text"
            :error="failedField === 'certificate'"
            label="Pažymėjimas"
          />
        </div>

        <div class="mb-4 flex-1">
          <base-label-check
            v-model="form.photo_agreement"
            type="text"
            :error="failedField === 'photo_agreement'"
            label="Sutinka fotografuotis"
          />
        </div>
      </div>

      <div v-if="form.outfit" class="mb-4">
        <base-label-input
          v-model="form.outfit_size"
          type="text"
          :error="failedField === 'outfit_size'"
          label="Aprangos dydis"
        />
      </div>

      <div class="mb-4">
        <base-label-input
          v-model="form.notes"
          type="text"
          :error="failedField === 'notes'"
          label="Komentaras"
        />
      </div>

      <div class="mb-4 flex flex-col lg:flex-row">
        <div class="w-full lg:w-64 mb-4">
          <base-submit :loading="isLoading" class="p-4">
            {{ isEdit ? 'Išsaugoti pakeitimus' : 'Sukurti profilį' }}
          </base-submit>
        </div>
        <base-btn-text
          v-if="isEdit"
          class="p-4 lg:ml-4 w-full lg:w-40 mb-4"
          @click="onClickFiles"
        >
          Failai
          <template v-if="userFiles && userFiles.length">
            ({{ userFiles.length }})
          </template>
        </base-btn-text>
        <base-btn-text
          v-if="isEdit"
          class="w-full p-4 lg:ml-4 mb-4 lg:w-40"
          @click="$router.push({ name: 'logs', params: { id: userId } })"
        >
          Veiksmų žurnalas
        </base-btn-text>
        <base-btn-text
          v-if="studies.length"
          class="p-4 lg:ml-4 w-full lg:w-48 mb-4"
          @click="onClickStudies"
        >
          Tęstiniai mokymai ({{ studies.length }})
        </base-btn-text>
        <base-btn-text
          v-if="isEdit"
          class="p-4 lg:ml-4 w-full lg:w-40 mb-4"
          @click="onClickInvite"
        >
          Siųsti pakvietimą
        </base-btn-text>
        <base-btn-text
          v-if="contracts && contracts.length"
          class="p-4 lg:ml-4 w-full lg:w-40 mb-4"
          @click="onClickContracts"
        >
          Sutartys ({{ contracts.length }})
        </base-btn-text>
        <base-btn-text
          class="p-4 lg:ml-4 w-full lg:w-40 mb-4"
          @click="$router.push({ name: 'hours', params: { id: userId } })"
        >
          Papildomos val.
        </base-btn-text>
        <base-btn-text
          v-if="isEdit && form.can_be_deleted"
          class="p-4 lg:ml-4 w-full lg:w-40 text-error mb-4"
          @click="onClickUserDelete"
        >
          Pašalinti
        </base-btn-text>
      </div>
    </form>

    <base-dialog
      v-if="dialogs.files.visible"
      title="Failai"
      :overlay-closes="true"
      @close="dialogs.files.visible = false"
    >
      <div class="-mx-8">
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th>Pavadinimas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in userFiles" :key="file.id">
              <td class="py-2">
                <div class="flex flex-column">
                  <div class="flex-grow">
                    <base-upload-link :filename="file.file_path">
                      {{ file.file_name }}
                    </base-upload-link>
                  </div>
                  <div>
                    <base-btn
                      type="danger"
                      class="ml-2 px-2 py-1"
                      @click="onClickFileDelete(file.id)"
                    >
                      Pašalinti
                    </base-btn>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="!userFiles.length">
              <td class="text-sm"> Nėra jokių įkeltų failų. </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template v-slot:buttons>
        <div class="w-32 relative cursor-pointer ml-4">
          <base-btn class="p-3">
            <input
              type="file"
              class="absolute top-0 left-0 right-0 bottom-0 opacity-0"
              @change="onFileChange($event.target.files[0])"
            />
            {{ dialogs.files.uploadBtnText }}
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.contracts.visible"
      title="Sutarčių istorija"
      :overlay-closes="true"
      @close="dialogs.contracts.visible = false"
    >
      <div class="-mx-8">
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th>Numeris</th>
              <th>Data nuo</th>
              <th>Data iki</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="contract in contracts" :key="contract.id">
              <td class="py-2">
                {{ contract.contract_no }}
              </td>
              <td class="py-2">
                {{ contract.contract_from }}
              </td>
              <td class="py-2">
                {{ contract.contract_to }}
              </td>
              <td class="text-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 text-gray-400 hover:text-gray-600 transition duration-300 cursor-pointer"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                  @click="onClickDeleteContract(contract)"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-dialog>

    <base-dialog
      v-if="dialogs.studies.visible"
      title="Tęstiniai mokymai"
      :overlay-closes="true"
      @close="dialogs.studies.visible = false"
    >
      <div class="-mx-8">
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th>Data</th>
              <th>Pavadinimas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="study in studies" :key="study.id">
              <td class="py-2">
                {{ study.event_date }}
              </td>
              <td class="py-2">
                {{ study.event_title }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-dialog>
  </Layout>
</template>
